export default "__VITE_ASSET__JKU$2J6D__"